import useOnboardingAutoOpen from "../../hooks/useOnboardingAutoOpen";

const OnboardingAutoOpenWrapper = ({ children }) => {
  // Use the hook to automatically open onboarding for new users
  useOnboardingAutoOpen();

  return <>{children}</>;
};

export default OnboardingAutoOpenWrapper;
